module.exports = __webpack_public_path__ + "5dd16492edf1f4c0a4f45ad824875def.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-icons/icon-savannah.png
// module id = 2994
// module chunks = 0